export function getIsTheLastTwapPart(composableCowInfo?: { isTheLastPart?: boolean }): boolean {
  return composableCowInfo?.isTheLastPart === true
}
